import React, { createContext, Dispatch, FC, ReactNode, SetStateAction, useState } from 'react';
import classNames from 'classnames';

import MainSiteNavigation from '@buyside/components/presentation/MainSiteNavigation/mainSiteNavigation';

import { useIsMobile } from '@buyside/util/hooks/useIsMobile';

import { Maybe } from '@interfaces/graphql-typings';

import styles from './mainSiteLayoutStyles.scss';

export const NavigationContext = createContext<
  Maybe<{
    sideNavigationOpen: boolean;
    setSideNavigationOpen: Dispatch<SetStateAction<boolean>>;
  }>
>(null);

const MainSiteLayout: FC<{
  currentUserFromRails: any;
  hideNavigation: boolean;
  RootComponent: ReactNode;
}> = ({ currentUserFromRails, hideNavigation, RootComponent }) => {
  const isMobile = useIsMobile();

  const [sideNavigationOpen, setSideNavigationOpen] = useState(
    isMobile
      ? false
      : localStorage.getItem('sideNavigationOpen')
      ? localStorage.getItem('sideNavigationOpen') === 'true'
      : true
  );

  const footer = document.getElementById('footer');
  if (footer) footer.classList.add(styles.mainSiteFooter);

  return (
    <NavigationContext.Provider value={{ sideNavigationOpen, setSideNavigationOpen }}>
      {hideNavigation ? null : (
        <nav className={styles.mainSiteNav} id="mainSiteNav">
          <MainSiteNavigation currentUserFromRails={currentUserFromRails} />
        </nav>
      )}
      <div
        className={classNames(styles.mainReactApp, {
          [styles.sideNavigationOpen]: sideNavigationOpen
        })}
        id="mainReactApp"
        data-hide-navigation={hideNavigation}
      >
        {RootComponent}
      </div>
    </NavigationContext.Provider>
  );
};

export default MainSiteLayout;
